import type { OrderBy } from '@/lib/graphql-query-builder';

/**
 * Scope note: the Food Request tab is read-only reporting in the Angular
 * source (no approve/reject workflow) with a client-side CSV export of the
 * selected day, ported in `utils/food-requests-csv.ts`.
 */
export const WEEKDAYS = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];

export interface LunchMenu {
  ItemId: string;
  Name: string;
  WeekDay: string;
  MenuItems: string[];
  IsActive: boolean;
}

export interface LunchMenusResult {
  totalCount: number;
  items: LunchMenu[];
}

export interface LunchMenuInsertInput {
  Name: string;
  WeekDay: string;
  MenuItems: string[];
  IsActive?: boolean;
}

export type LunchMenuUpdateInput = Partial<LunchMenuInsertInput> & {
  IsActive?: boolean;
};

// Note: the .NET write model (Food.Domain/Models/FoodRequestResponseModel.cs) uses
// `UserName` rather than `DisplayName`, but the live Blocks schema for LunchRequest
// (SCHEMA_REFERENCE.json) deliberately keeps `DisplayName` for consistency
// with the rest of the data model, so those are the names used here.
export interface LunchRequest {
  ItemId: string;
  UserId: string;
  DisplayName?: string;
  DepartmentName?: string;
  DepartmentKey?: string;
  MenuId?: string;
  MenuName?: string;
  MenuItems?: string[];
  /** The lunch day (date only): that day at 00:00:00 UTC, read by its date part. */
  RequestedForDate: string;
  CreatedDate?: string;
}

export interface LunchRequestsPagingResult {
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  totalCount: number;
  totalPages: number;
  pageSize: number;
  pageNo: number;
  items: LunchRequest[];
}

export interface GetLunchRequestsParams {
  pageNo: number;
  pageSize: number;
  filter?: Record<string, unknown>;
  /** Defaults to by department, then request time. */
  order?: OrderBy[];
}

export interface GetLunchMenusParams {
  pageNo: number;
  pageSize: number;
  filter?: Record<string, unknown>;
}
